import ApiNode from "./ApiNode";

export default {
  sendComprehensiveSlinePaymentReminder() {
    return ApiNode().post("comprehensive-sline-payment-reminder/send");
  }
};



// WEBPACK FOOTER //
// ./src/services/ComprehensiveSlinePaymentReminderService.js